import React from 'react';
import { FormBuilder } from 'commons-ui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useFixBucket from './useFixBucket';

const FixUsersBucket: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useFixBucket();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default FixUsersBucket;
